import IconOrderTypeG from '@/assets/icons/order-type/g.svg'
import { type OnlineOrderType, type OrderType, OrderTypeMapping, type TagIcon } from '@/types/api/restaurant'

export function filterOnlineOrderTypes(orderTypes: OrderType[]): OnlineOrderType[] {
  return orderTypes.filter(
    (orderType) => orderType !== 101 && orderType !== 104 && orderType !== 105 && orderType !== 107
  ) as OnlineOrderType[]
}

/**
 * @description Filters and sorts order types that are shown in tags on the restaurant pages
 * @param unfilteredOrderTypes - The order types to filter
 * @returns The filtered order types
 */
export function filterOrderTypeTags(unfilteredOrderTypes: OrderType[]): OrderType[] {
  const order: OrderType[] = [106, 102, 103, 104, 107]

  return order.filter((orderType) => unfilteredOrderTypes.includes(orderType))
}

/**
 * @description Combine order types and restaurant marketing tags (e.g. Gamechanger, Halal)
 * to create a list of chips
 * @param orderTypes - The order types to display
 * @param marketingTags - The marketing tags to display
 * @returns The list of chips
 */
export function getRestaurantTags(orderTypes: OrderType[], marketingTags?: string[]): TagIcon[] {
  const tags: TagIcon[] = []

  // If there are marketing tags, add them to the list of chips
  if (marketingTags?.length) {
    for (const tag of marketingTags) {
      tags.push({
        icon: IconOrderTypeG,
        name: tag
      })
    }
  }

  // Add order types to the list of chips
  for (const orderType of orderTypes) {
    tags.push({
      icon: OrderTypeMapping[orderType].icon,
      name: OrderTypeMapping[orderType].name
    })
  }

  return tags
}

/**
 * @description Prepends the restaurant name with the brand name
 * @param name - The restaurant name (e.g. "Balaclava")
 * @returns The restaurant name with the brand name prepended (e.g. "Grill'd Balaclava")
 */
export function prependBrandName(name: string): string {
  return !name.includes("Grill'd") ? `Grill'd ${name}` : name
}
